import { fetchGridViewModel } from "@/grid/data/fetch-grid-data";
import { getDepartment } from "@/grid/config/registry";
import type { GridViewModel } from "@/grid/core/types";
import { useQuery } from "@tanstack/react-query";

export function useGridData(departmentId: string, options?: { enabled?: boolean }) {
  const department = getDepartment(departmentId);
  const enabled = options?.enabled ?? true;

  return useQuery({
    queryKey: ["grid", departmentId],
    queryFn: async (): Promise<GridViewModel> => {
      if (!department) throw new Error(`Unknown department: ${departmentId}`);
      return fetchGridViewModel(department);
    },
    enabled: enabled && Boolean(department),
    staleTime: 5 * 60_000,
  });
}

export function useGridDepartment(departmentId: string) {
  return getDepartment(departmentId);
}
